var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tables"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('Navigation',{attrs:{"calculators":""}}),_vm._v(" "),_c('Tables')],1),_vm._v(" "),_c('QuizBanner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }